import { classInstance } from '@/shared/helpers/helpers';

export class SubjectSearch {
	constructor(selector) {
		this.$container = selector;

		if (!this.$container) return;

		this.init();
	}

	init() {
		classInstance.set(this.$container, { subjectSearch: this });
		this.$input = this.$container.querySelector('input');
		this.$closeButton = this.$container.querySelector('.subject-search__close');
		this.$container.addEventListener('submit', this.submitHandler.bind(this));
		this.$input.addEventListener('input', this.inputHandler.bind(this));
		this.$closeButton.addEventListener('click', this.clearInput.bind(this));
		document.addEventListener('keydown', this.keydownHandler.bind(this));
	}

	destroy() {
		classInstance.del(this.$container, 'subjectSearch');
		this.$container.removeEventListener('submit', this.submitHandler);
		this.$input.removeEventListener('input', this.inputHandler);
		this.$closeButton.removeEventListener('click', this.clearInput);
		document.removeEventListener('keydown', this.keydownHandler);
	}

	reinit() {
		this.destroy();
		this.init();
	}

	submitHandler(event) {
		event.preventDefault();
		this.dispatch('search', this.$input.value);
	}

	inputHandler() {
		if (this.$input.value) {
			this.$closeButton.classList.add('active');
		} else {
			this.$closeButton.classList.remove('active');
		}
	}

	clearInput() {
		this.$input.value = '';
		this.$closeButton.classList.remove('active');
		this.$input.dispatchEvent(new Event('input'));
		this.dispatch('search', this.$input.value);
	}

	keydownHandler(event) {
		if (event.key === 'Escape') {
			this.clearInput();
		}
	}

	dispatch(event, value) {
		this.$container.dispatchEvent(
			new CustomEvent(event, {
				detail: {
					value: value,
				},
			}),
		);
	}
}
